"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadStrokeColorUpdater = void 0;
const StrokeColorUpdater_1 = require("./StrokeColorUpdater");
function loadStrokeColorUpdater(tsParticles) {
    tsParticles.addParticleUpdater("strokeColor", () => new StrokeColorUpdater_1.StrokeColorUpdater());
}
exports.loadStrokeColorUpdater = loadStrokeColorUpdater;
